import { Pipe, PipeTransform } from '@angular/core';

//import { Flyer } from './electedofficials.component';

@Pipe({ name: 'federallevel' })
export class FederalLevelPipe implements PipeTransform {
  transform(Persons: Object[]) {

    if (Persons) {
      return Persons.filter(person => person["Level"] === "Federal");
    }
  }
}

@Pipe({ name: 'statelevel' })
export class StateLevelPipe implements PipeTransform {
  transform(Persons: Object[]) {
    if (Persons) {
      return Persons.filter(person => person["Level"] === "State");
    }
  }
}

@Pipe({ name: 'locallevel' })
export class LocalLevelPipe implements PipeTransform {
  transform(Persons: Object[]) {
    if (Persons) {
      return Persons.filter(person => person["Level"] === "Local");
    }
  }
}

@Pipe({ name: 'citylevel' })
export class CityLevelPipe implements PipeTransform {
  transform(Persons: Object[]) {
    if (Persons) {
      return Persons.filter(person => person["Level"] === "Indpls/Marion County");
    }
  }
}

@Pipe({ name: 'party' })
export class PartyPipe implements PipeTransform {
  transform(Persons: Object[], Party:string) {
    if (Persons) {
      if (Party){
        return Persons.filter(person => person["Party"] === Party);
      } else {
        return Persons;
      }
      
    }
  }
}

@Pipe({ name: 'specialelection' })
export class SpecialElectionPipe implements PipeTransform {
  transform(Persons: Object[], SpecialElection:boolean) {
    if (Persons) {
      return Persons.filter(person => person["SpecialElection"] === SpecialElection);
    }
  }
}


// WEBPACK FOOTER //
// ./app/shared/pipes/electionLevels.pipe.ts